/**
 * BackToTop.js
 *
 * Shows/hides a back-to-top button based on scroll position.
 * Smooth scrolls to top on click.
 */

export default class BackToTop {
	constructor() {
		this.btn = document.querySelector( '.js-back-to-top' );
		if ( ! this.btn ) return;

		this._bindEvents();
		this._onScroll(); // Set initial state.
	}

	_bindEvents() {
		window.addEventListener( 'scroll', () => this._onScroll(), { passive: true } );
		this.btn.addEventListener( 'click', () => {
			window.scrollTo( { top: 0, behavior: 'smooth' } );
		} );
	}

	_onScroll() {
		if ( window.scrollY > 400 ) {
			this.btn.classList.add( 'is-visible' );
			this.btn.setAttribute( 'aria-hidden', 'false' );
		} else {
			this.btn.classList.remove( 'is-visible' );
			this.btn.setAttribute( 'aria-hidden', 'true' );
		}
	}
}
